<template>
  <nav :class="bemFacets" class="wizard-navigation">
    <ul class="u-reset wizard-navigation__steps">
      <li
        v-for="{ icon, id, label, param } in visibleWizardStepList"
        :key="id"
        class="wizard-navigation__step"
      >
        <div class="wizard-navigation__clipper">
          <tooltip-initiator
            v-bind="tooltipProps"
            :is-enabled="id !== activeWizardStep.id"
            :label="label"
            @scroll="$event.toggle(false)"
          >
            <template #default="{ toggle, hasHover }">
              <n-link
                :class="getButtonClasses(id)"
                :to="getRouteLink(param)"
                class="wizard-navigation__btn btn btn--secondary btn--bubble"
                @mouseenter.native="hasHover ? null : toggle(true)"
                @mouseleave.native="hasHover ? null : toggle(false)"
                @touchstart.native="hasHover ? toggle(true) : null"
                @touchend.native="hasHover ? toggle(false) : null"
              >
                <responsive-img
                  :src="icon"
                  :width="50"
                  alt=""
                  class="wizard-navigation__step-icon"
                />
                <responsive-img
                  v-bind="$options.getArrow(activePageTheme, 'down', 'wizard_navigation')"
                  alt=""
                  class="wizard-navigation__step-arrow wizard-navigation__step-arrow--down"
                />
                <responsive-img
                  v-bind="$options.getArrow(activePageTheme, 'right', 'wizard_navigation')"
                  alt=""
                  class="wizard-navigation__step-arrow wizard-navigation__step-arrow--right"
                />
              </n-link>
            </template>
          </tooltip-initiator>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import bemMixin from '@/assets/js/mixin/bem'
  import { getArrow, getImage } from '@/assets/js/util/misc/image'
  import TooltipInitiator from '@/components/tooltip-initiator/tooltip-initiator'
  import { viewportWidthIds, viewportWidthList } from '@/assets/js/util/dom/viewport-width'
  import ResponsiveImg from '@/components/responsive-img/responsive-img'

  export default {
    components: { ResponsiveImg, TooltipInitiator },
    mixins: [bemMixin('wizard-navigation')],
    props: {
      progressIdx: {
        type: Number,
        required: true,
      },
      getRouteLink: {
        type: Function,
        required: true,
      },
      wizardStep: {
        type: Object,
        required: true,
      },
      wizardStepList: {
        type: Array,
        required: true,
      },
    },
    computed: {
      ...mapState('viewport', { viewportWidth: 'width' }),
      ...mapGetters('navigation', ['activePageTheme', 'activeWizardStep']),
      tooltipProps() {
        const mdViewport = viewportWidthList.find(({ id }) => id === viewportWidthIds.MD)

        if (this.viewportWidth < mdViewport.minValue) {
          return {
            originPosition: { x: 'center', y: 'start' },
            overlayPosition: { x: 'center', y: 'end' },
            position: ({ width, x, y }) => ({ x: x + width / 2, y: y + 4 }),
            transition: 'trs-to-top',
          }
        }

        return {
          originPosition: { x: 'end', y: 'center' },
          overlayPosition: { x: 'start', y: 'center' },
          position: ({ width, height, x, y }) => ({ x: x + width - 10, y: y + height / 2 }),
          transition: 'trs-to-right',
        }
      },
      visibleWizardStepList() {
        return this.wizardStepList.filter(({ inNav }) => inNav)
      },
    },
    methods: {
      ...mapActions('world-map', ['setMapConfig']),
      ...mapActions('overlay', ['closeOverlay', 'openOverlay']),
      getButtonClasses(stepId) {
        const idx = this.wizardStepList.findIndex(({ id }) => id === stepId)

        return [
          this.bemAdd(stepId === this.activeWizardStep.id && 'active', 'btn'),
          this.bemAdd(idx > this.progressIdx && 'upcoming', 'btn'),
        ]
      },
    },
    getArrow,
    getImage,
  }
</script>

<style lang="scss" src="./_wizard-navigation.scss" />
